export default __webpack_public_path__ + "static/media/ic-email.0a152959.svg";